var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.823242 21.0001V0.428711H41.9661V41.5716H0.823242V21.0001Z",
    fill: "#AAB2BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8043 27.1762C6.91694 26.8245 5.2156 24.8205 4.92114 21.4178C4.60214 17.6962 6.39345 15.1442 9.82066 14.4489C11.1212 14.1872 12.8552 14.4244 14.1558 15.046C15.0065 15.455 15.8244 16.2729 16.217 17.1154C16.5278 17.778 16.6577 18.6576 16.6577 18.6576L13.1742 18.6613L12.9125 18.1624C12.25 16.9191 10.5568 16.6492 9.46076 17.6144C8.60191 18.3669 8.23383 20.0519 8.54466 21.7941C8.83912 23.4054 9.64071 24.2316 10.9249 24.2316C12.1027 24.2316 13.3532 23.3582 13.3532 22.6874L11.6126 22.6918L11.6147 20.1418H17.0186L17.0199 26.2362L20.8384 15.1932H24.8873L29.0834 26.2369V14.8661H38.5716V17.5653L32.9013 17.5645L32.9009 20.0594L37.3856 20.06V22.7593H32.8868V27.0944L25.4527 27.0908L25.01 25.5403L20.6721 25.5342L20.1759 27.0944H14.4012L14.3998 25.5249C14.3998 25.5249 14.1476 25.7366 13.9022 25.9738C12.9125 26.9063 11.3584 27.3643 9.8043 27.1762ZM24.1348 23.0292C24.143 22.9147 22.8833 18.6286 22.8261 18.5632C22.777 18.5141 21.4355 23.0292 21.4355 23.0292H24.1348Z",
    fill: "#FDFAFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaf);
export default __webpack_public_path__ + "static/media/GAF.dc932bfd21a5949724213c5ea6a8d914.svg";
export { ForwardRef as ReactComponent };